import { INVENTORY_DASHBOARD_ERROR, GETTING_INVENTORY_DASHBOARD, GET_INVENTORY_DASHBOARD } from "../types"

const initialState = {
    inventoryData: null,
    loadingInventory: true,
    inventoryError: null,
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case GETTING_INVENTORY_DASHBOARD:
        return {
            ...state,
            loadingInventory: action.payload,
        }
        case GET_INVENTORY_DASHBOARD:
        return{
            ...state,
            loadingInventory: false,
            inventoryError: null,
            inventoryData: action.payload
        }
        case INVENTORY_DASHBOARD_ERROR:
        return{
            ...state,
            loadingInventory: false,
            inventoryError: action.payload
        }
        default:
        return state
    }
}
